import React from 'react';

import './index.css';
import './editor.css';
import type { UIComponentBase } from '../../../../../@types/types';

const Styling: React.FC<Pick<UIComponentBase, 'children'>> = ({ children }) => <>{children}</>;

export default Styling;
